import gql from 'graphql-tag'

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '';
let intermediateCondition = '';
if(cities && cities.length){
    cities.forEach(function(curnt){
        let clientStr = '{clientobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
        let pickupStr = '{pickuppartyobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
        let dropStr = '{droppingpartyobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
        intermediateCondition = intermediateCondition + clientStr + pickupStr + dropStr
    })
    finalCondition = ', {_or: ['+ intermediateCondition +']}'
}

export const SUBSCRIBE_PENDING_FOR_APPROVAL = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 pending_approval: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "154dcbf5-2ee8-b60d-9f0d-3709944337bd"}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails {id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_PICKUP_CONFIRMATION = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 pickup_confirmation: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "98d24789-d38d-4426-b6bc-1be53a18fb80"}},{ orderDetails: {pickupConfirmation: {_eq: "Awaiting"}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupConfirmation pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_PICKUP_READINESS = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 pickup_readiness: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "98d24789-d38d-4426-b6bc-1be53a18fb80"}},{ orderDetails: {orderReadiness: {_contains: {isOrderReady:false}}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails {id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_CREATE_LR = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 create_lr: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "98d24789-d38d-4426-b6bc-1be53a18fb80"}},{ orderDetails: {lrObject: {_contains: {islrReady: false}}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id lrObject pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_SEND_PICKUP_EMAIL = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 send_pickup_email: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "98d24789-d38d-4426-b6bc-1be53a18fb80"}},{ orderDetails: {lrObject: {_contains: {isEmailSent: false}}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id lrObject pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_DISPATCH_VERIFICATION = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 dispatch_verification: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "0d61b7c8-c508-42b4-8da6-ef087e68ea05"}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id dispactchVerification pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_EWAY_BILL = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 eway_bill: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "60e848de-41bb-4da4-b201-596107f1904f"}},{ orderDetails: {ewayBillNo: {_is_null: true}}}${finalCondition}]}, distinct_on: id){
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      materials
      priority
      note
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_ASSIGN_LOCAL_TRANSPORT = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 assign_local_transport: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "98d24789-d38d-4426-b6bc-1be53a18fb80"}},{ orderDetails: {pickupVehicleAssignId: {_is_null: true}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_TEMPO_SENT_FOR_PICKUP = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 tempo_sent_for_pickup: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "98d24789-d38d-4426-b6bc-1be53a18fb80"}},{ orderDetails: {pickupVehicleAssignId: {_is_null: false}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_TEMPO_REACHED_COMPANY = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 tempo_reached_company: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "ccefb0de-fc2b-4a46-8e3f-996f04f40351"}}${finalCondition}]}, distinct_on: id){
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      materials
      priority
      note
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_MATERIAL_LOADED = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 material_loaded: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "4b874954-4da5-4002-bbb7-52ba954c9b38"}}${finalCondition}]}, distinct_on: id){
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      materials
      priority
      note
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_TEMPO_LEFT_PICKUP_COMPANY = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 tempo_left_pickup_company: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "00fb7496-c2f1-4361-b653-9507419d2096"}}${finalCondition}]}, distinct_on: id){
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      materials
      priority
      note
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_ASSIGN_TRANSPORT_VEHICLE = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 assign_transport_vehicle: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     { internalstatus: {_neq: "912cba99-37cb-41fb-ae2e-2a472200af64"}},{ internalstatus: {_neq: "24e00980-9a93-496c-b422-7b17a9ddfc2a"}},
     { orderDetails: {transportVehicleAssignId: {_is_null: true}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_TO_LOAD_IN_TRUCK = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 to_load_in_truck: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "60e848de-41bb-4da4-b201-596107f1904f"}},{ orderDetails: {transportVehicleAssignId: {_is_null: false}}},
     { orderDetails: {loadedInTruck: {_eq: false}}},{ orderDetails: {ewayBillNo: {_is_null: false}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_TO_BE_DEPARTED = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 to_be_departed: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     { internalstatus: {_neq: "bcd55c8e-76f1-410b-ae50-51931ed987bf"}},{ internalstatus: {_neq: "ed2747e7-c86b-48c7-96db-b10c509c27cf"}},
     { internalstatus: {_neq: "ea40091b-fb89-4774-ab6d-ec34e638957e"}},{ orderDetails: {loadedInTruck: {_eq: true}}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id dispactchVerification pickupPoint dropPoint}
    }
 }
`

// let cities = JSON.parse(localStorage.getItem('cities'))
// let finalCondition = '';
// let intermediateCondition = '';
// if(cities && cities.length){
//     cities.forEach(function(curnt){
//         let dropStr = '{droppingpartyobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
//         intermediateCondition = intermediateCondition + dropStr
//     })
//     finalCondition = ', {_or: ['+ intermediateCondition +']}'
// }

export const SUBSCRIBE_TO_BE_ARRIVED = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 to_be_arrived: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     { internalstatus: {_eq: "bcd55c8e-76f1-410b-ae50-51931ed987bf"}}${finalCondition}]}, distinct_on: id){ 
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails{id dispactchVerification pickupPoint dropPoint}
    }
 }
`
export const SUBSCRIBE_AWAITING_FINAL_DELIVERY = gql`
 subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){ 
 awaiting_final_delivery: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}},{droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] },
     {internalstatus: {_eq: "ea40091b-fb89-4774-ab6d-ec34e638957e"}}${finalCondition}]}, distinct_on: id){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails {id pickupPoint dropPoint}
    }
 }
`
